import React from "react";
import creditCardIcon from "../../../assets/creditCardIcon.svg";
import { useNavigate } from "react-router-dom";
import styles from "./Add.module.scss";

const Add = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.container} onClick={() => navigate("/add-new-card")}>
      <img src={creditCardIcon} alt="credit-card" />
      <p>Add new</p>
    </div>
  );
};

export default Add;
